/**
 * Helper phía trình duyệt cho tiền tố ngôn ngữ (xem src/shared/localeRouting.js).
 * Worker inject window.QRCODE_ENV.LANGUAGE_PATH_PREFIX ("/en" | ""), Next dev inject qua _document.
 */
import {
  applyPathPrefix,
  getLanguagePathPrefix,
  isSupportedLanguage,
  normalizeLanguageCode,
  parseLanguagePath
} from "./localeRouting";

export function getClientLanguage() {
  if (typeof window === "undefined") return "";
  const raw = window.QRCODE_ENV?.DEFAULT_LANGUAGE;
  const normalized = normalizeLanguageCode(raw);
  return isSupportedLanguage(normalized) ? normalized : "";
}

/**
 * Tiền tố path đang phục vụ ("/en", "" ...). Ưu tiên giá trị server inject; nếu thiếu thì suy từ
 * ngôn ngữ + URL hiện tại (dev server không tiền tố → "").
 */
export function getClientLanguagePrefix() {
  if (typeof window === "undefined") return "";
  const injected = window.QRCODE_ENV?.LANGUAGE_PATH_PREFIX;
  if (typeof injected === "string") return injected;
  const language = getClientLanguage();
  const expected = getLanguagePathPrefix(language);
  if (!expected) return "";
  const pathname = window.location?.pathname || "/";
  return pathname === expected || pathname.startsWith(`${expected}/`) ? expected : "";
}

/** Path tương đối gốc → path có tiền tố ngôn ngữ hiện tại (URL tuyệt đối/asset giữ nguyên). */
export function toLocalHref(href) {
  const value = String(href || "");
  if (!value.startsWith("/") || value.startsWith("//")) return value;
  const prefix = getClientLanguagePrefix();
  if (!prefix) return value;
  const [pathPart, ...rest] = value.split(/(?=[?#])/);
  return `${applyPathPrefix(pathPart, prefix)}${rest.join("")}`;
}

/** Path hiện tại đã bỏ tiền tố ngôn ngữ (dùng cho so khớp route / SEO). */
export function getClientPathname() {
  if (typeof window === "undefined") return "/";
  return parseLanguagePath(window.location?.pathname || "/").pathname;
}

/**
 * Lưới an toàn: mọi <a href="/..."> chưa có tiền tố (markup cũ, nội dung CMS) được vá ngay lúc click
 * để không rơi về bản tiếng Việt ở root. <Link> của react-router đã có basename nên không bị đụng.
 */
export function installLocalizedLinkInterceptor() {
  if (typeof document === "undefined") return () => {};
  const handler = (event) => {
    const prefix = getClientLanguagePrefix();
    if (!prefix) return;
    const anchor = event.target?.closest?.("a[href]");
    if (!anchor) return;
    const rawHref = anchor.getAttribute("href") || "";
    if (!rawHref.startsWith("/") || rawHref.startsWith("//")) return;
    const localized = toLocalHref(rawHref);
    if (localized !== rawHref) anchor.setAttribute("href", localized);
  };
  document.addEventListener("click", handler, true);
  return () => document.removeEventListener("click", handler, true);
}
